import React from "react";
import {Page, Text, View, Document, StyleSheet, Font} from "@react-pdf/renderer";
import OpenSansRegular from "../../../../../statics/typos/openSansRegular.ttf";
import OpenSansSemiBold from "../../../../../statics/typos/openSansSemiBold.ttf";
import OpenSansBold from "../../../../../statics/typos/openSansBold.ttf";
import {OrderCargoFileModel} from "../../../../models/order";
import {OrderFilesUtils} from "../../../../../helpers/orderFilesUtils";

Font.register({
    family: "OpenSans",
    format: "truetype",
    src: OpenSansRegular
});
Font.register({
    family: "OpenSansSemiBold",
    format: "truetype",
    src: OpenSansSemiBold
});
Font.register({
    family: "OpenSansBold",
    format: "truetype",
    src: OpenSansBold
});

const styles = StyleSheet.create(OrderFilesUtils.styles);

interface ImportOrderCargoFileProps {
    order: OrderCargoFileModel | null | undefined,
    username: string
}

export default function ImportOrderCargoFile(props: ImportOrderCargoFileProps): React.ReactElement {
    if (!props.order) {
        return <Document><Page/></Document>;
    }

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View>
                    {OrderFilesUtils.renderHeader("ZLECENIE POBRANIA ŁADUNKU CARGO W IMPORCIE \n" +
                        "IMPORT ORDER CARGO")}
                    {renderTable()}
                </View>
            </Page>
        </Document>
    );

    function renderTable() {
        return (
            <View style={styles.table}>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderOrderType(props.order!.relationType)}
                    {OrderFilesUtils.renderOrderNo(props.order!.orderId)}
                    {OrderFilesUtils.renderBookingNo(props.order!.bookingNo)}
                    {OrderFilesUtils.renderVoyageNo(props.order!.voyageNo)}
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.renderFerry(props.order!.ferryName)}
                    </View>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.renderArrivalDepartureTime(props.order!.arrivalDepartureTime)}
                    </View>
                    {OrderFilesUtils.renderCargoType(props.order!.cargoType)}
                    <View style={styles.tableSmallCol}>
                        <Text style={[styles.tableCellHeader]}>
                            Numer ładunku /{"\n"}
                            Cargo no
                        </Text>
                        <Text style={[styles.tableCellData]}>
                            {OrderFilesUtils.renderMeansOfTransportNo({
                                trailerRegNo: props.order!.trailerRegNo,
                                lorryRegNo: props.order!.lorryRegNo,
                                wagonRegNo: props.order!.wagonRegNo,
                                containerNo: props.order!.containerNo
                            })}
                        </Text>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.renderCargoWeight(props.order!.weight)}
                    </View>
                    {OrderFilesUtils.renderCbm(props.order!.cbm)}
                    <View style={styles.tableCol}>
                        {OrderFilesUtils.renderDangerousGoods(props.order!.isDangerousGoods)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.requestedTemp(props.order!.requestedTemp1, 1)}
                    </View>
                    <View style={styles.tableSmallCol}>
                        {OrderFilesUtils.requestedTemp(props.order!.requestedTemp2, 2)}
                    </View>
                    <View style={styles.tableCol}>
                    </View>
                </View>
                <View style={styles.tableRow}>
                    <View style={styles.tableBigCol}>
                        {OrderFilesUtils.renderTransportCompany(props.order!.transportCompany)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderTimeOfDepositingLoad(props.order!.timeOfDepositingLoad)}
                    <View style={styles.tableMediumCol}>
                        {OrderFilesUtils.renderStorageTime(props.order!.storageTime)}
                    </View>
                </View>
                <View style={styles.tableRow}>
                    {OrderFilesUtils.renderPaymentMethod(props.order!.paymentMethod)}
                    {OrderFilesUtils.renderPaymentDocumentNumber(props.order!.paymentDocumentNumber)}
                </View>
                {OrderFilesUtils.renderRemarks(props.order!.remarks)}
                {OrderFilesUtils.requestedSignatures(true, props.username)}
            </View>
        );
    }
}

